import axios, { AxiosError } from 'axios';

/**
 * Axios instance gọi tới Gateway (cùng origin).
 * baseURL '/admin/api', dùng cookie phiên (session).
 */
export const apiClient = axios.create({
  baseURL: '/admin/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const LOGIN_PATH = '/admin/login';

/**
 * Khi bất kỳ API nào trả về 401 -> chuyển hướng về trang đăng nhập.
 * Bỏ qua chính endpoint /me và /login để tránh vòng lặp / hiển thị lỗi thừa.
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    const url = error.config?.url ?? '';
    const isAuthProbe = url.includes('/me') || url.includes('/login');

    if (status === 401 && !isAuthProbe) {
      const current = window.location.pathname;
      if (!current.startsWith(LOGIN_PATH)) {
        window.location.assign(LOGIN_PATH);
      }
    }
    return Promise.reject(error);
  },
);

/** Trích thông điệp lỗi thân thiện từ response. */
export function extractErrorMessage(error: unknown, fallback = 'Đã xảy ra lỗi'): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: string | string[] } | undefined;
    if (data?.message) {
      return Array.isArray(data.message) ? data.message.join(', ') : data.message;
    }
    return error.message || fallback;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}
